import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { JobFormFields } from 'parent-portal/forms/JobRequestTypes';
import React from 'react';
import { FieldStates } from '../../FormTypes';
import JobFormPage from '../JobFormPage';
import PreferredWorkersInput from './PreferredWorkersInput';
import PastWorkersInput from './PastWorkersInput';
import { styled } from '@mui/material';

interface ProviderPreferencesPageProps {
    fieldStates: FieldStates<JobFormFields>;
    title?: string;
    subtitle?: string;
    nextText?: string;
    submit?: () => void;
}

export default function ProviderPreferencesJobFormPage({
    fieldStates,
    title,
    subtitle,
    nextText = 'Next',
}: ProviderPreferencesPageProps) {
    const { preferredWorkers, pastWorkers, address } = fieldStates;
    const { goToNext } = useJobFormContext();

    function onNextClicked() {
        goToNext();
    }

    return (
        <JobFormPage
            onNextClicked={onNextClicked}
            title={title ?? 'Request Specific Workers'}
            nextText={nextText}
            subtitle={subtitle}
            nextDisabled={false}
            id="provider-preferences-page"
        >
            <PreferredWorkersInput
                selected={preferredWorkers.value}
                onChange={preferredWorkers.setValue}
                addresses={address.value?.map((x) => x.id)}
            />
            <Spacer />
            <PastWorkersInput selected={pastWorkers.value} onChange={pastWorkers.setValue} />
            <Spacer />
        </JobFormPage>
    );
}

const Spacer = styled('div')({
    marginTop: 30,
});
